import React, { useState, useEffect, forwardRef, useRef, useImperativeHandle } from "react";
import ReactDOM from 'react-dom';
import { useTranslation } from 'react-i18next';
import Select from 'react-select'

const MyDataMoreTaxesTypeEditor = forwardRef((props, ref) => {
    const [selectedVal, setSelectedVal] = useState(props.value);
    const [editing, setEditing] = useState(true);
    const refContainer = useRef(null);
    const refSelectInput = useRef(null);


    useEffect(() => {
        focus();
    }, []);

    useImperativeHandle(ref, () => {
        return {
            getValue() {
                return selectedVal != null ? selectedVal : props.value;
            },

            isPopup() {
                return true;
            }
        };
    });

    useEffect(() => {
        if (!editing) {
            props.api.stopEditing();
        }
    }, [editing]);

    const focus = () => {
        window.setTimeout(() => {
            let container = ReactDOM.findDOMNode(refContainer.current);
            if (container) {
                container.focus();
            }
        });
    };

    const { t, i18n } = useTranslation();

    const onSelectChange = val => {
        setSelectedVal(val);
        var old_val = props.node.data.type ? props.node.data.type.value : undefined;

        setTimeout(function () {
            props.api.stopEditing();
            console.log(props.colDef.cellRendererParams)
            var type = val.value
            var allTaxes = props.colDef.cellRendererParams.moreTaxesOptions;
            console.log(allTaxes)

            let groupTaxes = allTaxes.reduce((r, a) => {
                r[a.type] = [...r[a.type] || [], a];
                return r;
            }, {});

            var typeTaxes = groupTaxes[type];
            var new_type_options = []
            if (typeTaxes) {
                typeTaxes.forEach(element => {
                    new_type_options.push({
                        value: "TAX_" + element.value,
                        label: element.type == "DEDUCTION" ? element.label : t("TAX_" + element.value),
                        amountValue: element.amountValue,
                        uid: element.uid,
                        type: element.type,
                        id: element.id,
                        subtracted: element.type == "DEDUCTION" ? element.subtracted : null,
                    });
                });
            }
            props.node.setDataValue("type", val);
            setTimeout(function () {
                props.node.setDataValue("myDataMoreTaxes", new_type_options);
                // props.node.setDataValue("type", val);
                if (old_val != val.value) {
                    props.node.setDataValue("myDataMoreTax", { value: undefined, label: undefined });
                }
            }, 100)


        })

    }
    const onMouseOver = e => {
        refSelectInput.current.setState({ isOpen: true })
        let container = ReactDOM.findDOMNode(e.target).parentNode.getElementsByTagName("input")[0];
        if (container != undefined) {
            container.focus();
        }
    }


    return (<div style={{ width: props.column.actualWidth + 'px' }}>

        <span onMouseOver={onMouseOver} className="selectCell" ref={refContainer}>
            <Select
                autosize={true}
                menuIsOpen={true}
                defaultValue={selectedVal}
                onChange={onSelectChange}
                onChangeValue={onSelectChange}
                menuPortalTarget={document.body}
                styles={{
                    menu: (provided, state) => ({
                        ...provided,
                        minWidth: 250,
                        border: '4px #333',
                        zIndex: 9999
                    }), menuPortal: base => ({ ...base, zIndex: 9999 })
                }}
                options={props.colDef.cellRendererParams.options} ref={refSelectInput}>
            </Select>
        </span>
    </div>
    );
});
export default MyDataMoreTaxesTypeEditor